(function () {

    'use strict';

    const COLOR_PICKER_PARAMS = require('parameters/json/color-picker-config.json');

    class InterventionReasonDialogCtrl {
        constructor($mdDialog, $translate, hospitalizationService) {
            this.dialog = $mdDialog;
            this.hospitalizationService = hospitalizationService;

            this.options = _.assign(
                {}, COLOR_PICKER_PARAMS, {label: $translate.instant('reason_dialog_color')}
            );
        }

        static get $inject() {
            return ["$mdDialog", "$translate", "hospitalizationService"];
        }

        $onInit() {

        }

        submit() {
            this.promise = this.hospitalizationService.handleInterventionReason(this.model)
                .then(data => this.dialog.hide(data));
        }

        cancel() {
            this.dialog.cancel();
        }
    }

    module.exports = {
        multiple: true,
        controllerAs: "vm",
        bindToController: true,
        parent: $(document.body),
        clickOutsideToClose: true,
        controller: InterventionReasonDialogCtrl,
        template: require("./intervention-reason.dialog.tpl.html"),
    };

})();
